import { SidenavBaseFilterComponent } from '../../../../../core/base/components/sidenav/base-filter/sidenav-base-filter.component';
import { USER_PROFILE_FILTER_SCHEMA } from './user-profile-filter.schema';
import { AutocompleteService } from '../../../../../core/services/scroll.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SupplierService } from '../../supplier/supplier.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { EstablishmentService } from '../../establishment/establishment.service';
import { ActivityTypeService } from '../../../settings/activity-type/activity-type.service';

@Component({
  selector: 'user-profile-filter',
  templateUrl: './user-profile-filter.component.html',
  styleUrls: ['./user-profile-filter.component.scss'],
})
export class UserProfileFilterComponent extends SidenavBaseFilterComponent {
  override readonly schema = USER_PROFILE_FILTER_SCHEMA;
  showEstablishments: boolean;

  constructor(
    public establishmentService: EstablishmentService,
    public suppliersService: SupplierService,
    public authService: AuthService,
    public userProfileService: UserProfileService,
    public activityTypeService: ActivityTypeService,
    public autocompleteService: AutocompleteService,
    public snackbarService: SnackbarService,
  ) {
    super(snackbarService, autocompleteService);

    this.addForm(
      'standardForm',
      new UntypedFormGroup({
        lastName: new UntypedFormControl(),
        firstName: new UntypedFormControl(),
        contactType: new UntypedFormControl(),
        establishments: new UntypedFormControl(),
        activities: new UntypedFormControl(),
      }),
    );

    this.showEstablishments = (this.authService.currentUserValue().affectations?.length ?? 0) > 1;
  }

  initialize(): void {
    this.autocompleteContactType('');
    this.autocompleteEstablishment('');
    this.autocompleteActivity('');
  }

  autocompleteContactType(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'contactType', '_id', pageToGo, () =>
        this.userProfileService.findUsedContactTypes(),
      )
      ?.subscribe();
  }

  autocompleteEstablishment(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'establishments', '_id', pageToGo, (page, size) =>
        this.establishmentService.findAll(page, size, 'label', 'asc', search, { onlyMine: true }),
      )
      ?.subscribe();
  }

  autocompleteActivity(search: string = '', pageToGo?: 'next' | 'previous') {
    this.autocompleteService
      .autocompleteInfiniteScroll(search, 'activities', '_id', pageToGo, (page, size) =>
        this.activityTypeService.findAll(page, size, 'acronym', 'asc', search),
      )
      ?.subscribe();
  }

  onScrollLine(pageToGo: 'next' | 'previous', filterField: string): void {
    switch (filterField) {
      case 'establishments':
        this.autocompleteEstablishment('', pageToGo);
        break;
      case 'contactType':
        this.autocompleteContactType('', pageToGo);
        break;
      case 'activities':
        this.autocompleteActivity('', pageToGo);
        break;
      default:
        console.error('Unknown filterField:', filterField);
    }
  }
}
